module.exports = "<navbar2></navbar2>\r\n\r\n<main class1=\"dashboard-main-area\" ng-class=\"{'dashboard-main-area': $ctrl.authService.authData.userId}\">\r\n  <navbar></navbar>\r\n\r\n  <div class=\"app\">\r\n    <div ui-view></div>\r\n  </div>\r\n\r\n</main>\r\n\r\n<div growl></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 1884
// module chunks = 0